import React from 'react';
import { FiExternalLink, FiCopy, FiMinus, FiPlus } from 'react-icons/fi';
import './DistrictContextMenu.scss';

interface DistrictContextMenuProps {
  x: number;
  y: number;
  district: any;
  onClose: () => void;
  onOpenDistrict: () => void;
  /** Adding the district to a beacon or removing it, first in the menu; none without one. */
  beaconAction?: { verb: 'Added' | 'Removed'; label: string; onClick: () => void };
}

export default function DistrictContextMenu({ x, y, district, onClose, onOpenDistrict, beaconAction }: DistrictContextMenuProps) {
  const handleCopyName = () => {
    if (district?.name) {
      navigator.clipboard.writeText(district.name);
      onClose();
    }
  };

  const handleCopyId = () => {
    if (district?.id) {
      navigator.clipboard.writeText(district.id);
      onClose();
    }
  };

  return (
    <>
      {/* Backdrop to capture clicks outside the menu */}
      <div className="context-menu-backdrop" onClick={onClose} />

      <div
        className="district-context-menu"
        style={{
          position: 'fixed',
          left: x,
          top: y,
          zIndex: 10000
        }}
      >
        {beaconAction && (
          <>
            <div className="context-menu-item" onClick={beaconAction.onClick}>
              {beaconAction.verb === 'Added' ? (
                <FiPlus className="context-menu-icon" />
              ) : (
                <FiMinus className="context-menu-icon" />
              )}
              <span>{beaconAction.label}</span>
            </div>

            <div className="context-menu-divider" />
          </>
        )}

        <div className="context-menu-item" onClick={onOpenDistrict}>
          <FiExternalLink className="context-menu-icon" />
          <span>View Details</span>
        </div>

        <div className="context-menu-divider" />

        <div className="context-menu-item" onClick={handleCopyName}>
          <FiCopy className="context-menu-icon" />
          <span>Copy Name</span>
        </div>

        <div className="context-menu-item" onClick={handleCopyId}>
          <FiCopy className="context-menu-icon" />
          <span>Copy ID</span>
        </div>
      </div>
    </>
  );
}
